var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3:239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.181 16.7686V15.1716C14.181 14.3245 13.8445 13.5121 13.2455 12.9131C12.6465 12.3141 11.8341 11.9776 10.987 11.9776H4.59893C3.75182 11.9776 2.93941 12.3141 2.34041 12.9131C1.74142 13.5121 1.40491 14.3245 1.40491 15.1716V16.7686",
    stroke: "currentcolor",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79302 8.78354C9.55702 8.78354 10.987 7.35353 10.987 5.58953C10.987 3.82552 9.55702 2.39551 7.79302 2.39551C6.02901 2.39551 4.599 3.82552 4.599 5.58953C4.599 7.35353 6.02901 8.78354 7.79302 8.78354Z",
    stroke: "currentcolor",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.972 16.7686V15.1716C18.9715 14.4639 18.736 13.7764 18.3024 13.2171C17.8688 12.6578 17.2618 12.2583 16.5765 12.0814",
    stroke: "currentcolor",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3826 2.49933C14.0696 2.67524 14.6786 3.07481 15.1134 3.63505C15.5483 4.19529 15.7843 4.88433 15.7843 5.59353C15.7843 6.30274 15.5483 6.99178 15.1134 7.55202C14.6786 8.11225 14.0696 8.51183 13.3826 8.68774",
    stroke: "currentcolor",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3:239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.1641,
    height: 19.1641,
    fill: "currentcolor",
    transform: "translate(0.606445)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.7412ffa2c72284a6b20f08c627950733.svg";
export { ForwardRef as ReactComponent };